import { render } from "./pdvLayout.vue?vue&type=template&id=710cd1e2&scoped=true"
import script from "./pdvLayout.vue?vue&type=script&lang=js"
export * from "./pdvLayout.vue?vue&type=script&lang=js"

import "./pdvLayout.vue?vue&type=style&index=0&id=710cd1e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710cd1e2"]])

export default __exports__